module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av300-7ff9572ff3bf98cfa1f9770eaa1fe870.jpg";